export const MODAL_SWITCH = 'MODAL_SWITCH';
export const CONFIRM_MODAL_SWITCH = 'CONFIRM_MODAL_SWITCH';
export const MODAL_SAVE_FORM = 'MODAL_SAVE_FORM';
export const MODAL_LOADER_BTN = 'MODAL_LOADER_BTN';
export const MODAL_CONFIRM_DATA = 'MODAL_CONFIRM_DATA';
